import axios from 'axios'
import config from '@/mixins/config'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

const onSuccess = (resp) => {
  if (isDebug) {
    console.log(' << ' + JSON.stringify(resp.data))
  }
  return Promise.resolve(resp.data)
}

const onError = (err, bvModal) => {
  let errorMsg = 'エラーが発生しました'
  if (err.response && err.response.data && err.response.data.message) {
    errorMsg = err.response.data.message
  } else if (err.response && err.message) {
    errorMsg = err.message
  }

  bvModal.msgBoxOk(errorMsg, {
    title: '',
    size: 'sm',
    buttonSize: 'sm',
    okVariant: 'primary',
    okTitle: '確認',
    headerClass: 'p-2 border-bottom-0',
    footerClass: 'p-2 border-top-0',
    //  align-items-start
    centered: true,
    dialogClass: 'align-items-start t-10r'
  }).then(value => {
    this.boxTwo = value
  }).catch(err => {
    console.log(err)
    // An error occurred
  })
  throw new Error('API error.')
}

export default {
  get: (path, bvModal, params, callbackSuccess, callbackError, callbackFinally) => {
    let resSuccess = onSuccess
    if (callbackSuccess) {
      resSuccess = callbackSuccess
    }

    let resError = onError
    if (callbackError) {
      resError = callbackError
    }

    if (isDebug) {
      let logMsg = 'GET ' + config.data().config.apiURL + path
      if (params) {
        logMsg += ' params:: ' + JSON.stringify(params)
      }
      console.log(logMsg)
    }

    axios.defaults.withCredentials = true

    const axiosInstance = axios.create({
      withCredentials: true,
      baseURL: config.data().config.apiURL
    })

    return axiosInstance.get(path, {'params': JSON.stringify(params)}).then(resSuccess).catch(err => {
      console.log(err)
      resError(err, bvModal)
    }).finally(callbackFinally)
  },
  post: (path, bvModal, params, callbackSuccess, callbackError, callbackFinally) => {
    let resSuccess = onSuccess
    if (callbackSuccess) {
      resSuccess = callbackSuccess
    }

    let resError = onError
    if (callbackError) {
      resError = callbackError
    }

    if (isDebug) {
      let logMsg = 'POST ' + config.data().config.apiURL + path
      if (params) {
        logMsg += ' params:: ' + JSON.stringify(params)
      }
      console.log(logMsg)
    }

    axios.defaults.withCredentials = true

    const axiosInstance = axios.create({
      withCredentials: true,
      baseURL: config.data().config.apiURL
    })

    return axiosInstance.post(path, params).then(resSuccess).catch(err => {
      console.log(err)
      // 全画面共通処理でbvModalがnullのとき、下記の処理を飛ばす
      if (bvModal !== null) {
        resError(err, bvModal)
      }
    }).finally(callbackFinally)
  },
  put: (path, bvModal, params, callbackSuccess, callbackError, callbackFinally) => {
    let resSuccess = onSuccess
    if (callbackSuccess) {
      resSuccess = callbackSuccess
    }

    let resError = onError
    if (callbackError) {
      resError = callbackError
    }

    if (isDebug) {
      let logMsg = 'PUT ' + config.data().config.apiURL + path
      if (params) {
        logMsg += ' params:: ' + JSON.stringify(params)
      }
      console.log(logMsg)
    }

    axios.defaults.withCredentials = true

    const axiosInstance = axios.create({
      withCredentials: true,
      baseURL: config.data().config.apiURL
    })

    return axiosInstance.put(path, params).then(resSuccess).catch(err => {
      console.log(err)
      resError(err, bvModal)
    }).finally(callbackFinally)
  },
  delete: (path, bvModal, params, callbackSuccess, callbackError, callbackFinally) => {
    let resSuccess = onSuccess
    if (callbackSuccess) {
      resSuccess = callbackSuccess
    }

    let resError = onError
    if (callbackError) {
      resError = callbackError
    }

    if (isDebug) {
      let logMsg = 'DELETE ' + config.data().config.apiURL + path
      if (params) {
        logMsg += ' params:: ' + JSON.stringify(params)
      }
      console.log(logMsg)
    }

    axios.defaults.withCredentials = true

    const axiosInstance = axios.create({
      withCredentials: true,
      baseURL: config.data().config.apiURL
    })

    return axiosInstance.delete(path, {'params': JSON.stringify(params)}).then(resSuccess).catch(err => {
      console.log(err)
      resError(err, bvModal)
    }).finally(callbackFinally)
  },
  getStore: (name, mainContentName, key) => {
    if (store.getters.model === null || !(name in store.getters.model)) {
      return null
    }

    if (mainContentName) {
      if (!(mainContentName in store.getters.model[name])) {
        return null
      }

      if (!key) {
        return store.getters.model[name][mainContentName]
      }

      if (key in store.getters.model[name][mainContentName]) {
        return store.getters.model[name][mainContentName][key]
      }
    } else {
      if (!key) {
        return store.getters.model[name]
      }

      if (key in store.getters.model[name]) {
        return store.getters.model[name][key]
      }
    }

    return null
  },
  validateStatus: (res) => {
    if (res.status !== 'success') {
      let errorMessage = config.data().consts.errorMsg.api
      if (res.message) {
        errorMessage = res.message
      }

      throw new Error(errorMessage)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/AppModel.js